import { nanoid } from 'nanoid'

export const getOrCreateDeviceId = (): string => {
  const existing = localStorage.getItem('device_id')
  if (existing) return existing

  const deviceId = nanoid(50)
  localStorage.setItem('device_id', deviceId)
  return deviceId
}
